/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from "react";
import { IDataResult, Result } from "../../common/models/Result";
import { Authentication } from "../../common/views/Authentication";
import { DataUtils } from "../../common/views/DataUtils";
import { PreferenceService } from "../../favorites/services/PreferenceService";
import { ProductFeatureType, RecommendedProductFilterModel, ShortLineModel } from "../../products/models/ProductModel";

export default function useCustomerHomeVM() {
    const service = new PreferenceService();

    const [recentViews, setRecentViews] = useState<ShortLineModel[]>([]);
    const [choices, setChoices] = useState<ShortLineModel[]>([]);
    const [newArrivals, setNewArrivals] = useState<ShortLineModel[]>([]);
    const [specialSales, setSpecialSales] = useState<ShortLineModel[]>([]);
    const [topRates, setTopRates] = useState<ShortLineModel[]>([]);
    const [topSales, setTopSales] = useState<ShortLineModel[]>([]);

    const [selectedProduct, setSelectedProduct] = useState<ShortLineModel | undefined>(undefined);
    const [showProductDetail, setShowProductDetail] = useState(false);

    const [isExecutingSummary, setIsExecutingSummary] = useState(false);

    const onLoad = () => {
        const customerId = Authentication.getCustomer();
        const intCustomerId = customerId ? Number(customerId) : 0;

        if (Authentication.isLoggedIn()) {
            executeSummary(intCustomerId);
        }

        getAllRecommendedProducts(intCustomerId);

        if (intCustomerId > 0) {
            getRecentViews(intCustomerId);
        }
    }

    const getRecentViews = (customerId: number) => {
        const onResult = (result: IDataResult) => {
            setRecentViews(result.data);
        }

        const request = service.getRecentViews(customerId);
        DataUtils.onRequest(request, onResult, false);
    }

    const executeSummary = (customerId: number) => {
        if (isExecutingSummary) return;

        setIsExecutingSummary(true);

        const onResult = (result: IDataResult) => {
            setIsExecutingSummary(true);
            //getAllRecommendedProducts(customerId);
        }

        const request = service.executeSummary();
        DataUtils.onRequest(request, onResult, false);
    }

    const getAllRecommendedProducts = (customerId: number) => {
        getRecommendedProducts(customerId, ProductFeatureType.choice, 10);
        getRecommendedProducts(customerId, ProductFeatureType.newArrival, 10);
        getRecommendedProducts(customerId, ProductFeatureType.specialSale, 10);
        getRecommendedProducts(customerId, ProductFeatureType.topRate, 10);
        getRecommendedProducts(customerId, ProductFeatureType.topSale, 10);
    }

    const getRecommendedProducts = (customerId: number, type: ProductFeatureType, maxCount: number) => {
        const model: RecommendedProductFilterModel = {
            token: "",
            type: type,
            maxCount: maxCount
        };

        const request = service.getRecommendedProducts(customerId, model);

        DataUtils.onRequest(
            request,
            (result: IDataResult) => onRecommendedProductsResult(result, type, maxCount),
            false
        );
    }

    const onRecommendedProductsResult = (result: IDataResult, type: ProductFeatureType, maxCount: number) => {
        const products = result.data;

        switch (type) {
            case ProductFeatureType.choice:
                setChoices(products);
                break;
            case ProductFeatureType.newArrival:
                setNewArrivals(products);
                break;
            case ProductFeatureType.specialSale:
                setSpecialSales(products);
                break;
            case ProductFeatureType.topRate:
                setTopRates(products);
                break;
            case ProductFeatureType.topSale:
                setTopSales(products);
                break;
        }
    }

    return {
        onLoad,

        choices,
        newArrivals,
        specialSales,
        topRates,
        topSales,
        recentViews,

        selectedProduct, setSelectedProduct,
        showProductDetail, setShowProductDetail
    }
}